<template>
  <div>
    <v-divider class="mt-1" :color="theme.orders_divider_color" />
    <v-layout 
      row
      style="margin-bottom: -10px;"
    >
      <v-flex xs12>
        <v-checkbox
          v-model="usePointsModel"
          :color="theme.btn_color_secondary"
          :dark="dark"
          @change="changeUsePoints"
        >
          <template slot="label">
            <span :style="nameStyle">{{ $t('use_my_points') }}</span>
          </template>
        </v-checkbox>
      </v-flex>
    </v-layout>
    <div
      v-if="usePointsModel"
      style="margin-top: -18px"
    >
      <v-layout row>
        <v-flex
          xs9
          sm9
          md9
          lg10
          xl10
          text-xs-right
        >
          <h4 :style="nameStyle">Points payment:</h4>
        </v-flex>
        <v-flex
          xs3
          sm3
          md3
          lg2
          xl2
          text-xs-right
        >
          <h4 :style="nameStyle">{{ $n(activeOrderPayments.points, 'currency') }}</h4>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex
          xs9
          sm9
          md9
          lg10
          xl10
          text-xs-right
        >
          <h4 :style="nameStyle">Payable amount:</h4>
        </v-flex>
        <v-flex
          xs3
          sm3
          md3
          lg2
          xl2
          text-xs-right
        >
          <h4 :style="nameStyle">{{ $n(activeOrderPayments.topay_payment, 'currency') }}</h4>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      usePointsModel: null
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme'
    ]),
    ...mapGetters('order', [
      'usePoints', 'activeOrderPayments', 'paymentMode'
    ]),
    ...mapGetters('member', [
      'points'
    ]),
    dark () {
      return parseInt(this.theme.main_menu_theme) === 1
    },
    nameStyle () {
      return {
        color: this.theme.orders_name_color
      }
    }
  },
  methods: {
    changeUsePoints () {
      if (this.usePointsModel) {
        this.$store.dispatch('order/enableUsePoints')
        // Reset paymentMode if it is a noPaymentMode
        if (this.paymentMode && this.paymentMode.payType === 'noPayment') {
          this.$store.dispatch('order/resetPaymentMode')
        }
      } else {
        this.$store.dispatch('order/disableUsePoints')
      }
    }
  },
  async mounted () {
    this.usePointsModel = this.usePoints
    await this.$store.dispatch('member/fetchProfile')
    if (!this.points) {
      this.usePointsModel = false
      this.$store.dispatch('order/disableUsePoints')
    }
  }
}
</script>

<style scoped>
.icon-img {
  height: 44px;
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/UsePoints.vue